// extracted by mini-css-extract-plugin
export default {"wrap":"Sr-z","logoContainer":"Tr-z","brandImg":"Ur-z","logoImg":"Vr-z","logoButton":"Wr-z"};